import type { FetchRequestError } from "@lib/errors/FetchRequestError";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { MultiLanguageCompositionSetup } from "@lib/messageComposition";
import type {
  SHARED_CONSTANTS_AUTHENTICATION_CREDENTIAL_ERROR_CODES,
  SHARED_CONSTANTS_LIQUID_CONSTANTS,
} from "@lib/shared_constants";

import type { WebhookMessageTemplateIdResult } from "../webhookMessageTemplateId";

export type WebhookTemplateInvalidContentBlockReferenceError = FetchUserEncodedError<
  SHARED_CONSTANTS_LIQUID_CONSTANTS["CONTENT_BLOCKS"]["ERROR_CODES"]["INVALID_CONTENT_BLOCK_REFERENCE"],
  { content_block_names: string[] }
>;

export type WebhookTemplateInvalidCredentialIdError = FetchUserEncodedError<
  SHARED_CONSTANTS_AUTHENTICATION_CREDENTIAL_ERROR_CODES["INVALID_ID"]
>;

export type WebhookTemplateUpsertError =
  | WebhookTemplateInvalidContentBlockReferenceError
  | WebhookTemplateInvalidCredentialIdError;

export const isWebhookTemplateUpsertError = (error: FetchRequestError): error is WebhookTemplateUpsertError => {
  return error instanceof FetchUserEncodedError;
};

export interface WebhookTemplatePayload {
  id: string;
  name?: string | null;
  description?: string | null;
  webhook_body?: string | null;
  webhook_body_type?: string | null;
  webhook_method?: string | null;
  webhook_url?: string | null;
  webhook_credential_id?: string | null;
  webhook_headers?: any;
  tag_names?: string[];
  territory_ids?: string[];
  marked_as_deleted?: boolean | null;
  api_identifier?: string | null;
  multi_language_composition_setup?: MultiLanguageCompositionSetup | null;
}

export interface PostEngagementWebhookTemplatesIdResponse {
  info: string;
  template: WebhookMessageTemplateIdResult;
}

export interface PostEngagementWebhookTemplatesIdProps {
  id: string;
}
